function normalizeKeyword(value) {
  return String(value || "").trim().toLowerCase();
}

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function buildPolicyLookup(keywordUsePolicies = []) {
  const lookup = new Map();
  for (const item of asArray(keywordUsePolicies)) {
    const keyword = normalizeKeyword(item?.keyword || item?.normalizedKeyword || item?.term || item?.word || item);
    if (!keyword || lookup.has(keyword)) continue;
    lookup.set(keyword, item);
  }
  return lookup;
}

function isBlockedForSearchTerms(policy, { operatorApproved = true } = {}) {
  if (!operatorApproved) {
    if (!policy || typeof policy !== "object") return true;
    if (["forbidden", "ads_only"].includes(String(policy.policy || "").trim().toLowerCase())) return true;
    return asArray(policy.blockedFields)
      .map((field) => String(field || "").trim().toLowerCase())
      .includes("searchterms");
  }
  // `selectedKeywords` is the operator-approved Step02 set. Legacy automatic
  // policy labels such as ads_only or an absent classification must not erase
  // that explicit approval. Only a manual placement restriction or a concrete
  // brand/IP signal remains authoritative at this client-side preview layer;
  // the server still rechecks facts, IP, language, duplicates and byte limits.
  if (!policy || typeof policy !== "object") return false;
  const policyName = String(policy.policy || "").trim().toLowerCase();
  const externalBrand = String(policy?.evidence?.externalBrand || "").trim();
  const risks = asArray(policy.risks).join(" ").toLowerCase();
  const explicitRisk = Boolean(externalBrand)
    || /(?:trademark|brand|intellectual property|infringement|商标|品牌|侵权)/u.test(risks);
  if (policyName === "forbidden" && (policy.manuallyAdjusted === true || explicitRisk)) return true;
  return policy.manuallyAdjusted === true && asArray(policy.blockedFields)
    .map((field) => String(field || "").trim().toLowerCase())
    .includes("searchterms");
}

export function filterSelectedKeywordsForSearchTerms(
  selectedKeywords = [],
  keywordUsePolicies = [],
  options = {},
) {
  const lookup = buildPolicyLookup(keywordUsePolicies);
  const seen = new Set();
  const result = [];

  for (const item of asArray(selectedKeywords)) {
    const keyword = String(item || "").trim();
    const normalized = normalizeKeyword(keyword);
    if (!keyword || seen.has(normalized)) continue;

    const policy = lookup.get(normalized);
    if (isBlockedForSearchTerms(policy, options)) continue;

    seen.add(normalized);
    result.push(keyword);
  }

  return result;
}
